
export const makePriceString = ({
  amount,
  currency,
}: {
  amount: number;
  currency: string;
}): string => {
  return currency === "usd"
    ? "$" + amount.toFixed(2)
    : amount.toFixed(2) + currency;
};
